// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import INITIAL_STATE from '../orderCreation/initialState.json';

export type ShippingAddressStoreType = Readonly<typeof INITIAL_STATE>;

export function saveCustomerServiceLocationAddress(
    state: any,
    { payload }: { payload: any }
): ShippingAddressStoreType {
    if (payload) {
        return {
            ...state,
            customerServiceLocationAddress: { ...payload },
        };
    }
    return state;
}